import {
  keepPreviousData,
  useQuery,
  type UseQueryResult,
} from '@tanstack/react-query';
import service from '../service';
import {
  statsRangeParams,
  type FirstTouchStats,
  type StatsRange,
} from '@Types/messagingStats';

export function useFirstTouchStats(
  flowId: string | null,
  range: StatsRange,
): UseQueryResult<FirstTouchStats, Error> {
  return useQuery<FirstTouchStats, Error>({
    queryKey: ['engagement-stats', 'first-touch', flowId, statsRangeParams(range)],
    queryFn: () => service.getFirstTouchStats(flowId as string, range),
    enabled: Boolean(flowId),
    placeholderData: keepPreviousData,
  });
}
